// layout header value
export const HEADER = {
  H_MOBILE: 56,
  H_MAIN_DESKTOP: 88,
  // dashboard layout 상단 헤더 높이
  H_DASHBOARD_TOP_RIGHT_HEADER_DESKTOP: 0,
  H_DASHBOARD_TOP_LEFT_HEADER_DESKTOP: 12,
  H_DASHBOARD_TOP_HEADER_MOBILE: 64,
  // dashboard layout 상당 헤더 z-index
  Z_DASHBOARD_TOP_HEADER: 1200,
  // dashboard layout 스크린 헤더 높이
  H_DASHBOARD_SCREEN_HEADER_DESKTOP: 48,
  H_DASHBOARD_SCREEN_HEADER_MOBILE: 30,
  // dashboard layout 스크린 푸터 높이
  H_DASHBOARD_SCREEN_FOOTER_DESKTOP: 0,
  H_DASHBOARD_SCREEN_FOOTER_MOBILE: 80,
  // dashboard layout 스크린 헤더 z-index
  Z_DASHBOARD_SCREEN_HEADER: 1100,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

// nav value
export const NAV = {
  W_BASE: 280,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  H_DASHBOARD_ITEM: 36,
  H_DASHBOARD_ITEM_SUB: 36,
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

// nav icon value
export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};
